import { getDecimalPlaces, round } from "../number";
export function encodeSeriesFilters({ type, point }) {
    var _a, _b;
    const series = point.series.userOptions;
    // Start with the series filters and the aggregation type ("stat")
    const filters = Object.assign(Object.assign({}, series.filters), { stat: String(series.statId) });
    if (type === "timeseries") {
        // When viewing sessions from a time series, the date is the time range of the point
        if (series.xValueRounding === "start") {
            const startDate = point.x / 1000;
            const endDate = startDate + series.xInterval;
            filters.date = { s: startDate, e: endDate };
        }
        else {
            const endDate = point.x / 1000;
            const startDate = endDate - series.xInterval;
            filters.date = { s: startDate, e: endDate };
        }
    }
    else {
        // For other chart types, the date is the whole series date range
        const date = { s: series.startTime, e: series.endTime };
        filters.date = date;
    }
    if (type === "distribution") {
        // For distribution charts, apply a metric threshold based on the selected point
        const lowerBound = point.x;
        const upperBound = round(point.x + series.xInterval, getDecimalPlaces(series.xInterval));
        const threshold = { m: series.metricQualified, l: lowerBound, u: upperBound };
        filters.metricBounds = threshold;
    }
    else if ((_b = (_a = series.settings) === null || _a === void 0 ? void 0 : _a.metric_bounds) === null || _b === void 0 ? void 0 : _b.length) {
        // For all other chart types, apply any metric thresholds from the series settings
        const { metric, upperBound, lowerBound } = series.settings.metric_bounds[0];
        const threshold = { m: metric, l: lowerBound, u: upperBound };
        filters.metricBounds = threshold;
    }
    if (type === "map") {
        filters.regions = point.location;
    }
    return filters;
}
export function viewSessionsFromTimeSeries(point) {
    const series = point.series.userOptions;
    if (series.metricQualified.substring(0, 4) === "LUX|") {
        // "View Sessions" link
        if (series.xInterval && series.filters) {
            const url = new URL(`${window.SPEEDCURVE_CONFIG.accountUrl}/lux-sessions/`, window.location.origin);
            const filters = encodeSeriesFilters({ type: "timeseries", point });
            url.searchParams.set("metric", series.metricQualified);
            url.searchParams.set("filters", JSON.stringify(filters));
            return url;
        }
    }
}
export function viewSessionsFromDistribution(point) {
    const series = point.series.userOptions;
    if (series.metricQualified.substring(0, 4) === "LUX|") {
        if (series.xInterval && series.filters) {
            const url = new URL(`${window.SPEEDCURVE_CONFIG.accountUrl}/lux-sessions/`, window.location.origin);
            const filters = encodeSeriesFilters({ type: "distribution", point });
            if (filters.metricBounds) {
                const { l, u } = filters.metricBounds;
                url.searchParams.set("fl", String(l));
                url.searchParams.set("fu", String(u));
            }
            url.searchParams.set("metric", series.metricQualified);
            url.searchParams.set("filters", JSON.stringify(filters));
            return url;
        }
    }
}
export function viewSessionsFromMap(point) {
    const series = point.series.userOptions;
    if (series.metricQualified.substring(0, 4) === "LUX|") {
        if (series.type === "mapbubble" && series.filters) {
            const url = new URL(`${window.SPEEDCURVE_CONFIG.accountUrl}/lux-sessions/`, window.location.origin);
            const filters = encodeSeriesFilters({ type: "map", point });
            // The map metric is almost definitely `country`, so we set that as the "dmetric"
            // (demographic metric) when linking to the Sessions dashboard.
            url.searchParams.set("dmetric", series.metricQualified);
            url.searchParams.set("filters", JSON.stringify(filters));
            return url;
        }
    }
}
